import { Button, Modal } from "@/components/atoms";
import { StateRatesEditAction } from "./types";

interface StateRatesModalsProps {
  action: StateRatesEditAction;
  selectedRange: number | null;
  onDeleteRange: () => void;
  onResetAndDeleteSettings: () => void;
  onClose: () => void;
}

export const StateRatesModals = ({
  action,
  selectedRange,
  onDeleteRange,
  onResetAndDeleteSettings,
  onClose,
}: StateRatesModalsProps) => {
  return (
    <>
      <Modal
        className="w-[85vw] md:w-[400px] lg:w-[400px]"
        open={action === "deleteRange"}
        title={`Delete Range ${selectedRange}`}
        description={`This will delete Range ${selectedRange}. You cannot undo this action.`}
        onClose={onClose}
        renderButtons={() => (
          <div className="flex flex-row w-full gap-3">
            <Button variant="secondary" size="lg" onClick={onClose} className="flex-1">
              Cancel
            </Button>
            <Button variant="primary" size="lg" onClick={onDeleteRange} className="flex-1 bg-danger border-none hover:bg-danger-dark">
              Delete
            </Button>
          </div>
        )}
      />
      <Modal
        className="w-[85vw] md:w-[400px] lg:w-[400px]"
        open={action === "resetAndDeleteSettings"}
        title="Reset and Delete Settings"
        description={`By clicking "Reset and Delete," all the setting for this pricing will be cleared. Please note that this action is irreversible.`}
        onClose={onClose}
        renderButtons={() => (
          <div className="flex flex-row w-full gap-3">
            <Button variant="secondary" size="lg" onClick={onClose} className="flex-1">
              Cancel
            </Button>
            <Button variant="primary" size="lg" onClick={onResetAndDeleteSettings} className="flex-1 bg-danger border-none hover:bg-danger-dark">
              Reset and Delete
            </Button>
          </div>
        )}
      />
    </>
  );
};
